export default {
    validate(pa) {

        // 120/080 = Sistólica/Diastólica.

        if (typeof pa === 'string' && pa.length === 7) {

            const [esquerda, direita] = pa.split('/')

            const sistolica = parseInt(esquerda)
            const diastolica = parseInt(direita)

            if (sistolica > 300) {

                return 'A pressão Sistólica deve ser menor ou igual a 300'
            }

            if (diastolica > 300) {

                return 'A pressão Diastólica deve ser menor ou igual a 300'
            }

            if (parseInt(diastolica) >= parseInt(sistolica)) {

                return 'A pressão Diastólica ( à direita da / ) deve ser menor que a da esquerda'
            }
        }

        return true
    },
}